<template>
  <div class="alert" :class="{[`alert-${alertClass}`]: true}">
    <slot>
      {{ message }}
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    alertClass: {
      type: String,
      required: false,
      default: 'danger'
    },
    message: {
      type: String,
      required: false
    }
  }
}
</script>
